import React, { useState } from "react";
import { Dialog } from "@mui/material";
import { Mic, Square, Search, RotateCcw } from "lucide-react";

interface VoiceRecorderProps {
    onResult: (text: string) => void;
    buttonLabel?: string;
}

const VoiceRecorder: React.FC<VoiceRecorderProps> = ({
    onResult,
    buttonLabel = "Voice Search",
}) => {
    const [showVoiceModal, setShowVoiceModal] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [speechText, setSpeechText] = useState("");
    const [hasProcessed, setHasProcessed] = useState(false);
    const [recognitionInstance, setRecognitionInstance] = useState<any>(null);

    const normalizeSpeechText = (text: string) => {
        const cleaned = text
            .replace(/[.,!?;:]/g, "") // remove punctuation
            .replace(/\s+/g, " ")
            .trim();

        const voterIdCandidate = cleaned.replace(/\s+/g, "").toUpperCase();

        const voterIdPattern = /^[A-Z]{3}\d{7}$/;

        if (voterIdPattern.test(voterIdCandidate)) {
            return voterIdCandidate;
        }

        return cleaned;
    };

    const startVoiceInput = () => {
        const SpeechRecognition =
            (window as any).SpeechRecognition ||
            (window as any).webkitSpeechRecognition;

        if (!SpeechRecognition) {
            alert("Voice recognition not supported in this browser");
            return;
        }

        const recognition = new SpeechRecognition();

        recognition.lang = "en-IN";
        recognition.interimResults = true;
        recognition.continuous = true;

        setShowVoiceModal(true);
        setIsRecording(true);
        setSpeechText("");

        recognition.start();
        setRecognitionInstance(recognition);

        recognition.onresult = (event: any) => {
            const transcript = Array.from(event.results)
                .map((r: any) => r[0].transcript)
                .join("");

            setSpeechText(transcript);
        };
        // recognition.onresult = (event: any) => {
        //     if (hasProcessed) return;
        //
        //     const lastResultIndex = event.results.length - 1;
        //     const transcript = event.results[lastResultIndex][0].transcript;
        //
        //     setSpeechText(transcript);
        //     setHasProcessed(true);
        // };
        // recognition.onspeechend = () => {
        //     recognition.stop();
        // };
        //
        // recognition.onend = () => {
        //     if (speechText) {
        //         const normalized = normalizeSpeechText(speechText);
        //         onResult(normalized);
        //         setShowVoiceModal(false);
        //     }
        // };
        recognition.onerror = (event: any) => {
            console.error("Speech recognition error:", event.error);
        };
    };

    const stopRecording = () => {
        if (recognitionInstance) recognitionInstance.stop();
        setIsRecording(false);
        if (speechText) {
            const normalizedText = normalizeSpeechText(speechText);

            // send to parent (SearchVoterList)
            onResult(normalizedText);

            // close modal
            setShowVoiceModal(false);
        }
    };
    //
    // const stopRecording = () => {
    //     if (recognitionInstance) {
    //         recognitionInstance.stop();
    //     }
    //
    //     setIsRecording(false);
    //
    //     if (speechText) {
    //         const normalized = normalizeSpeechText(speechText);
    //
    //         onResult(normalized);
    //
    //         setShowVoiceModal(false);
    //     }
    // };
    const handleSearch = () => {
        onResult(speechText);
        setShowVoiceModal(false);
    };

    return (
        <>
            <button
                type="button"
                onClick={startVoiceInput}
                className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-all ${
                    isRecording
                        ? "bg-red-500 text-white shadow-lg"
                        : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-100"
                } `}
            >
                <Mic size={18} />
                {/*<span className="hidden sm:block"></span>*/}
            </button>

            <Dialog
                open={showVoiceModal}
                onClose={() => setShowVoiceModal(false)}
                fullWidth
                maxWidth="xs"
            >
                <div className="flex flex-col items-center gap-6 p-8">
                    <div
                        className={`flex h-20 w-20 items-center justify-center rounded-full ${isRecording ? "animate-pulse bg-red-500" : "bg-gray-400"}`}
                    >
                        <Mic size={30} color="white" />
                    </div>

                    <h3 className="text-lg font-semibold">
                        {isRecording ? "Listening..." : "Voice Input"}
                    </h3>

                    <div className="min-h-[40px] text-center text-gray-700">
                        {speechText || "Speak something..."}
                    </div>

                    <div className="flex gap-4">
                        {isRecording && (
                            <button
                                onClick={stopRecording}
                                className="flex items-center gap-2 rounded-lg bg-red-500 px-4 py-2 text-white"
                            >
                                <Square size={16} />
                                Stop
                            </button>
                        )}

                        {!isRecording && (
                            <>
                                <button
                                    onClick={handleSearch}
                                    className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white"
                                >
                                    <Search size={16} />
                                    Search
                                </button>

                                <button
                                    onClick={startVoiceInput}
                                    className="flex items-center gap-2 rounded-lg border px-4 py-2"
                                >
                                    <RotateCcw size={16} />
                                    Retry
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default VoiceRecorder;
